// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lsn-question-block .lsn-control-checkboxes .lsn-control-checkbox {
  flex-wrap: wrap;
}
.lsn-question-block .lsn-control-checkboxes .lsn-control-checkbox:has(textarea) {
  margin-bottom: 1rem !important;
}
.lsn-question-block .lsn-control-checkboxes input:not(:checked) ~ .question-answer-comment-wrapper textarea:not(:placeholder-shown) {
  text-decoration: line-through !important;
}
.lsn-question-block .question-answer-comment-wrapper {
  flex-basis: 100%;
  margin-left: 1.7rem;
  margin-top: 0.3rem;
  position: relative;
}
.lsn-question-block .question-answer-comment-wrapper .fa-comment-alt-lines {
  position: absolute;
  top: 0;
  z-index: 1;
  transform: translate(50%, 50%);
}
.lsn-question-block .question-answer-comment-wrapper textarea {
  padding-left: 1.7rem;
}
.lsn-question-block .question-answer-comment-wrapper textarea + .control-error-wrapper {
  flex-basis: 100%;
  position: relative;
}
.lsn-question-block .question-answer-comment-wrapper textarea ~ .fa-comment-alt-lines {
  color: var(--main-border-color);
}
.lsn-question-block .question-answer-comment-wrapper textarea:focus ~ .fa-comment-alt-lines {
  color: var(--main-primary-color);
}
.lsn-question-block .question-answer-comment-wrapper textarea[required] ~ .fa-comment-alt-lines::after {
  position: absolute;
  content: '*';
  left: -0.4rem;
  top: -0.4rem;
  font-family: var(--main-font-family);
  color: var(--main-red);
}
.lsn-question-block .question-answer-comment-wrapper textarea.has-error ~ .fa-comment-alt-lines {
  color: var(--main-red);
}
`, "",{"version":3,"sources":["webpack://./src/pages/recommendationForm/QuestionBlock/components/Question.less"],"names":[],"mappings":"AAAA;EAIM,eAAA;AAFN;AAIM;EACE,8BAAA;AAFR;AALA;EAaM,wCAAA;AALN;AARA;EAmBI,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;AARJ;AAdA;EAyBM,kBAAA;EACA,MAAA;EACA,UAAA;EACA,8BAAA;AARN;AApBA;EAgCM,oBAAA;AATN;AAvBA;EAmCQ,gBAAA;EACA,kBAAA;AATR;AA3BA;EAwCQ,+BAAA;AAVR;AAaM;EAEI,gCAAA;AAZV;AAiBQ;EACE,kBAAA;EACA,YAAA;EACA,aAAA;EACA,YAAA;EACA,oCAAA;EACA,sBAAA;AAfV;AAmBM;EACE,sBAAA;AAjBR","sourcesContent":[".lsn-question-block {\n\n  .lsn-control-checkboxes {\n    .lsn-control-checkbox {\n      flex-wrap: wrap;\n\n      &:has(textarea) {\n        margin-bottom: 1rem !important;\n      }\n    }\n\n    // cross out the text when the checkbox is not checked\n    input:not(:checked)~.question-answer-comment-wrapper textarea:not(:placeholder-shown) {\n      text-decoration: line-through !important;\n    }\n  }\n\n  // TODO: consider moving this to the question comment component\n  .question-answer-comment-wrapper {\n    flex-basis: 100%;\n    margin-left: 1.7rem;\n    margin-top: .3rem;\n    position: relative;\n\n    .fa-comment-alt-lines {\n      position: absolute;\n      top: 0;\n      z-index: 1;\n      transform: translate(50%, 50%);\n    }\n\n    textarea {\n      padding-left: 1.7rem;\n\n      +.control-error-wrapper {\n        flex-basis: 100%;\n        position: relative;\n      }\n\n      ~.fa-comment-alt-lines {\n        color: var(--main-border-color);\n      }\n\n      &:focus {\n        ~.fa-comment-alt-lines {\n          color: var(--main-primary-color);\n        }\n      }\n\n      &[required]~.fa-comment-alt-lines {\n        &::after {\n          position: absolute;\n          content: '*';\n          left: -.4rem;\n          top: -.4rem;\n          font-family: var(--main-font-family);\n          color: var(--main-red);\n        }\n      }\n\n      &.has-error~.fa-comment-alt-lines {\n        color: var(--main-red);\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
